// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box-shadow-small":"styles__box-shadow-small___8D9Ei","boxShadowSmall":"styles__box-shadow-small___8D9Ei","box-shadow-medium":"styles__box-shadow-medium___15tEm","boxShadowMedium":"styles__box-shadow-medium___15tEm","box-shadow-large":"styles__box-shadow-large___2ULmu","boxShadowLarge":"styles__box-shadow-large___2ULmu","toggle":"styles__toggle___au3Zi","checkbox":"styles__checkbox___xaXED"};
    if(module.hot) {
      // 1771211554167
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  